import { RootState } from '@state/store';
import { createSelector } from 'reselect';
import { PriceCalendarMonthlyState, PriceCalendarState } from '@model/state/price-calendar-state';
import { Offer } from '@model/iceberg/service/price-calendar/monthly-response';
import { ISO_8601_DATE_FORMAT } from '@model/common';
import moment from 'moment';

export const getPriceCalendarState = (state: RootState) => state.priceCalendar;

export const getPriceCalendarMonthly = createSelector(
  getPriceCalendarState,
  (state: PriceCalendarState): PriceCalendarMonthlyState => state.monthly
);
export const getPriceCalendarMonthlyOffers = createSelector(
  getPriceCalendarState,
  (state: PriceCalendarState): Array<Offer> => state.monthly.response.data.prices || []
);
export const getPriceCalendarSelectedDay = createSelector(
  getPriceCalendarState,
  (state: PriceCalendarState): string => state.monthly.date
);
export const getPriceCalendarDefaultDay = createSelector(
  getPriceCalendarState,
  (state: PriceCalendarState): string => state.monthly.defaultDate
);
export const getPriceCalendarSelectedOffer = createSelector(
  getPriceCalendarMonthly,
  (monthly: PriceCalendarMonthlyState) => {
    const day: moment.Moment = moment(monthly.date, ISO_8601_DATE_FORMAT);
    return monthly.response.data.prices.find((offer: Offer) => moment(offer.date, ISO_8601_DATE_FORMAT).isSame(day));
  }
);
export const getPriceCalendarDefaultOffer = createSelector(
  getPriceCalendarMonthly,
  (monthly: PriceCalendarMonthlyState) => {
    const day: moment.Moment = moment(monthly.defaultDate, ISO_8601_DATE_FORMAT);
    return monthly.response.data.prices.find((offer: Offer) => moment(offer.date, ISO_8601_DATE_FORMAT).isSame(day));
  }
);
export const getIsPriceCalendarMonthlyLoading = createSelector(
  getPriceCalendarState,
  (state: PriceCalendarState): boolean => state.monthly.response.loading
);
